const translation = {
    'login_mfa': 'I have a MFA code',
    'system': 'System',
    'edit': 'Edit',
    'stop_edit': 'Stop Editing',
    'destination': 'Destination',
    'choose_a_destination': 'Choose a destination',
    'move': 'Move',
    'subjects': 'Subjects | Subject',
    'topics': 'Topics | Topic',
    'start_typing': 'Start typing',
    'today': 'Today',
    'yesterday': 'Yesterday',
    'no_date': 'No date',
    'anonymous': 'Anonymous',
    'hide_roster': 'Digitale Klassenmap',
    'download_teacher_error_title': 'Select a school',
    'download_teacher_error_text': 'Select at least one school to download teacher data from.',
    'teachers_data': 'Teachers data',
    'users': 'User | User',
    'role': 'Role | Roles',
    'create_new_user': 'Create a new user',
    'reset_password': 'Reset Password',
    'password': 'Password',
    'toStudent': 'To {item}',
    'grade': 'Grade',
    'choose_level': 'Choose a level',
    'choose_period': 'Choose a period',
    'global_user': {
        role: 'Global User | Global Users',
    },
    'navigation': {
        scoolcore: 'sCoolCore',
        scooladmin: 'sCoolAdmin',
        roster: 'Roster',
    },
    'trashed': {
        title: 'Inactive items',
    },
    'Show inactive items': 'Show inactive items',
    'Only show active items': 'Only show active items',
    'students': {
        tab: {
            school_tracker_description: 'Stukje tekst over Mijn PLP',
            this_is_me_description: 'Stukje tekst over Dit ben ik',
            portfolio_description: 'Stukje tekst over Mijn Drive',
            levels_description: 'Stukje tekst over Niveaus',
            profile_description: 'Stukje tekst over Profiel',
            messages_description: 'Stukje tekst over Berichten',
            notes_description: 'Stukje tekst over Notities',
            treatment_description: 'Stukje tekst over Ondersteuning',
            lvs_description: 'Stukje tekst over LVS',
            finished_description: 'Stukje tekst over Successen',
            roster_description: 'Stukje tekst over Mijn Rooster',
            plan: 'Stukje tekst over Documenten',
        },
    },
    'deleted': 'Deleted',
    'delete': 'Delete',
    'report': {
        no_areas: 'No areas have been created',
        no_areas_subtext: 'You can go to Curriculum > New Area to create one.',
        target: 'Target',
        reference_level: 'Reference Level',
        score: 'Score',
        period: 'Period',
        date: 'Date',
        choose_filter: 'Apply the filters above first in order to display information.',
        headers: {
            group: 'Group',
            lvs: 'Analysis',
        },
        sub_headers: {
            prev_period: 'Previous Period',
            curr_period: 'Current Period',
            notes: 'Notes',
            target: 'Target / Ambition',
        },
    },
    'auth': {
        login: 'Login',
        set_mfa_page: 'Set MFA',
        invalid: 'The credentials provided are invalid. Please try again.',
        logout: 'Logout',
        forgot: {
            title: 'Forgot Password',
            instruction: 'Teachers and guardians can request a new password for their account by entering their email address below. Students may request a new password by their teacher. Instructions will be sent by email.',
            submit: 'Send Email',
            contact: 'Contact your school administrator to reset your password.',
            login: 'No account? Click here',
        },
        reset: {
            title: 'Reset password',
            instruction: 'Create a new password.',
            submit: 'Reset',
        },
        submitted: {
            success: 'Done!',
            sent: 'We have sent you  email to {email}.',
            again: 'Log in again',
        },
        password: 'Password',
        confirm_password: 'Confirm password',
        no_match: 'Your passwords do not match',
        required: 'Password is required',
        mfa: 'MFA Token',
        mfa_title: 'Setup Multi-factor authentication',
    },
    'goalsetSelect': {
        title: 'Show goalset',
        showGoalsetOnly: 'Goalset goals',
        showAll: 'All goals',
        showStudentGoalsOnly: 'Student goals',
    },
    'dashboard': {
        title: 'sCoolDesk',
        welcome: 'Welcome {name}',
        intro: "It's nice to have you again.",
        finished: 'This period completed {item}',
    },
    'roster': {
        title: 'sCoolRoster',
        planner: 'Planner',
        autoplanner: 'Autoplanner',
        preplanner: 'Preplanner',
        preplannerExplanation: "With the pre-planner you pre-plan students to mandatory lessons where they only have 1 option to choose from for the given period. If the pre-planner already planned a student to a lesson it can't be reset by running the pre-planner again. If you want to undo the previous results of the pre-planner, you should first execute the pre-run job and then run the pre-planner again.",
        attention: 'ATTENTION!',
        prerun: 'Prerun',
        preRunExplanation: 'With the pre-run you reset the specified period. This means that all possible choices made by students will be deleted. Based on the settings and goals per lesson, it is then determined which students are invited to which lessons.',
        start: 'Start',
        clickHere: 'Click here',
        runTime: 'It can take at least 30 minutes for the autoplanner to complete.',
        autoplannerExplanation: "At this time the roster is automatically finished for all students. For all courses where a student hasn't made a choice yet, the computer will automatically make this for them.",
        autoplannerExplanation_2: 'The autoplanner tries to make a choice for all students who still have a choice. The autoplanner takes into account a number of rules (such as the capacity of a room). It is therefore possible that not all students can be linked to a lesson.',
        softLock: 'Soft-lock',
        softLockExplanation: "Only the times for all the course before and on this date can't be adjusted anymore. The content of these courses can still be edited by teacher. Students are still able to choose.",
        hardLock: 'Hard-lock',
        hardLockLockExplanation: "the course content and course times of all the courses before and on this date can't be edited anymore. Student are unable to choose a course.",
        visibleTeacher: 'Visibility Teacher',
        visibleTeacherExplanation: 'All courses before and on this date are visible for the teachers. All courses after this date are not visible for the teachers',
        visibleStudent: 'Visibility Student',
        visibleStudentExplanation: 'All courses before and on this date are visible for students. All courses after this date are not visible for students.',
        autoPlannerWeekInterval: 'Auto planner week interval',
        autoPlannerWeekIntervalExplanation: 'Stel hier in hoeveel weken de Autoplanner vooruit moet inplannen. Standaard is dit 1 week.',
        release_teacher: 'Make available to teachers',
        release_teacherExplanation: "At this time the roster will be automatically made available to teachers in order for them to add subjects to the courses. The roster administrator won't be able to edit the course times",
        release_student: 'Make available to students',
        release_studentExplanation: 'At this time the roster will be automatically made available to students in order for them to chose a course.',
        blockPlanner: 'Block choices',
        blockPlannerExplanation: "At this time the roster is automatically made unavailable for students. Students won't be able to chose their courses.",
        finalRoster: 'Rooster final',
        finalRosterExplanation: "At this time the roster will be made final. Course times and course content can't be changed anymore. Students will not be able to chose courses.",
        settings: 'sCoolPlanner settings',
        settingsWeek: 'Week settings roster',
        settingsGeneral: 'Current roster values',
        myRoster: 'sCoolPlanner',
        myLessons: 'My courses',
        hours: 'Hours',
        workHours: 'Working hours',
        calendar: 'Calendar',
        dialog: {
            subjects: 'Subject(s)',
            lessonType: 'Lesson Type',
            overview: 'Overview',
            select: 'Select',
            addComment: 'Add a comment below',
            lessonMandatory: 'Lesson mandatory',
            amountOfStudents: 'Amount of students',
            invite: 'Invite',
            invited: 'Invited',
            mandatoried: 'Mandatory',
            is_default: 'Lesson Condition',
            mandatory: 'Students & goals overview',
            notMandatoried: 'Not mandatory',
            mandatoryErrorTitle: 'Course cannot be choses',
            mandatoryErrorMessage: 'You cannot choose this event because you already have a mandatory class at this time.',
            sameLevelNotFinished: 'Same level as lesson, but NOT finished',
            sameLevelFinished: 'Same level as lesson, but finished',
            notSameLevelPLP: 'NOT same level as lesson, but in PLP',
            others: 'NOT in this lesson',
            selectOtherStudents: 'Invite other students',
            lessonOverview: 'Lesson overview',
            description: 'Description',
            mandatoryAndInvitation: 'Mandatory and Invitation',
            edit: 'Edit lesson',
            noSubjects: 'No subject(s) selected',
            noLessonType: 'No lessontype selected',
            inviteExtra: 'Invite other students',
        },
        activities: 'activity | activities',
        lessons: 'lesson | lessons',
        information: {
            title: 'Planner information',
            red: 'This lesson can no longer be changed.',
            blue: 'A choice cannot be made.',
            orange: 'No lesson has been selected yet.',
            green: 'A lesson has been chosen.',
        },
    },
    'tool': {
        title: 'sCoolPlanner',
        buttons: {
            subject: 'Learning Goals overview',
            presence: 'Presence',
            students: 'Students',
            edit_class: 'Edit class',
        },
        alert: {
            text: 'No lessons were found for the selected day.',
            subtext: 'Try choosing another day or adding a new lesson first.',
        },
        search: 'Search for a schedule',
        sync: {
            message: "Click the button below to sync the school's roster.",
            in_progress: 'The school is currently being synced. When this is done you can start a new sync',
            warning: 'Syncing a roster can take up to 30 minutes',
            button: 'Start roster sync',
        },
    },
    'notifications': {
        title: 'sCoolMessenger',
        title_overview: 'sCoolMessenger history',
        today: 'Today',
        alert: {
            text: 'No Messages',
            subtext: 'You have not received any messages yet.',
        },
        delete: 'Mark selection as read',
        delete_all: 'Mark all as read',
        message: {
            content: 'has placed a message on',
            at: 'at',
        },
        view_all: 'View all messages',
        tabs: {
            chat: 'Student pages',
            plp: 'PLP pop-up',
            group: 'Group chats',
            subject: 'Subjects',
            new_chat: 'New messages',
        },
        finished: {
            title: 'Subject Finished!',
        },
    },
    'scoollinks': {
        title: 'sCoolLinks',
        alert: {
            text: 'No sCoolLinks',
            subtext: 'You have not created any sCoolLinks yet.',
        },
        dialog: {
            create: {
                title: 'Create sCoolLink',
                subtitle: 'Create sCoolLink',
                submitting: 'sCoolLink is being saved',
                submitted: 'sCoolLink created',
            },
            edit: {
                title: 'Edit sCoolLink',
                subtitle: 'Edit sCoolLink',
                submitting: 'sCoolLink is being saved',
                submitted: 'sCoolLink changed',
            },
            delete: {
                title: 'sCoolLink delete',
                subtitle: 'sCoolLink delete',
                text: 'Are you sure that you want to delete this?',
            },
        },
    },
    'back': 'Back',
    'search': 'Search',
    'avatar': {
        title: 'Profile picture',
        change: 'Change picture',
    },
    'name': {
        title: 'Name',
        first: 'First Name',
        middle: 'Middle Name',
        last: 'Last Name',
    },
    'age': {
        title: 'Age',
    },
    'profile': {
        parnassys: {
            title: 'Parnassys',
            placeholder: 'Enter parnassys id',
            label: 'Parnassys ID',
        },
        title: 'Profile | Profiles',
        setting: 'Setting | Settings',
        mine: 'My Profile',
        standard: 'Standard Information',
        contact: {
            information: 'Contact Information',
            person: 'Contact person',
            number: 'Contact number',
        },
        tag: {
            information: 'Type Student',
        },
        extra: 'Medical Information',
        dob: 'Date of Birth',
        guardians: 'Parents/Guardians',
        students: 'Students',
        email: 'Email',
        phone: 'Phone number',
        allergy: 'Allergy | Allergies',
        medicine: 'Medicine | Medicines',
        password: {
            title: 'New Password',
            forgot: 'Forgot your password?',
            confirm: 'Confirm password',
            change: 'Change password',
        },
        group: 'Group',
        groups: 'Groups',
        login: 'Login as',
        level: {
            title: 'Class/Level',
            information: 'Class/Level information',
        },
        finished: {
            title: 'Successes',
        },
        parnassys_group: 'Parnassys Group',
        coach: 'Coach Group',
        room: 'Room',
        class: 'Coregroup',
        url: 'Url',
        language: 'Language',
        type: 'Type',
        address: 'Address',
        street: 'Street',
        housenumber: 'House number',
        addition: 'Addition',
        zipcode: 'Zip code',
        city: 'City',
        rotateImage: 'Rotate selected image',
        project: 'Project',
        my_subject_overview: 'Go to my subjects',
        add_support: 'Add support',
    },
    'library': {
        title: 'Library',
    },
    'curricula': {
        title: 'All Curricula',
        add: 'Add Curriculum',
        form: {
            upload: 'Click to upload a curriculum.',
            uploading: 'We are busy with uploading your curriculum',
            problem: 'There is possible a problem detected',
            hint: {
                p1: 'To upload a curriculum with you need a fixed format. Download the format here',
                p2: '',
            },
            redirect: 'When your new curriculum "{name}" is uploaded, it will open here.',
            moment: 'One moment please.',
            error: 'Uploading your curriculum takes a bit longer than normal. We are checking if something went wrong.',
            support: "Please try again, if it doesn't work, than go to sCoolHelp for support.",
        },
        searchDialog: {
            title: 'Search subject',
            placeholder: 'Search subject',
            selected_title: 'Selected subjects',
            headers: {
                area: 'Area',
                subject: 'Subject',
                level: 'Level',
                period: 'Period',
                actions: 'Actions',
            },
            actions: {
                apply: 'Apply',
            },
        },
    },
    'curriculum': {
        title: 'Curriculum',
        import: {
            area: {
                title: 'Import Areas with Topics and Learning Goals.',
                header: 'New Area |  New Areas',
                success: 'The new Area has been added to your curriculum',
            },
            topic: {
                title: 'Import Topics and Learning Goals for an existing Area.',
                header: 'New Topic |  New Topics',
                success: 'The new Topic has been added to your curriculum',
            },
            subject: {
                title: 'Import Learning Goals for an existing Area and Topic.',
                header: 'New Learning Goals |  New Learning Goals',
                success: 'The new Learning Goals have been added to your curriculum',
            },
        },
        area: {
            exclude: {
                button: 'Exclude area',
                message: 'Are you sure you want to exclude this area from the automatically generated PDPs?',
            },
            include: {
                button: 'Include area',
                message: 'Are you sure you want to include this area from the automatically generated PDPs?',
            },
            periodChange: {
                button: 'Ingore on period change',
                ignoreStatus: {
                    title: "Don't adjust status of subjects on period change ",
                    button: "Yes, don't adjust status",
                    message: 'During a period change the statusses of the subject of this area will not be adjusted. Are you sure?',
                },
                updateStatus: {
                    title: 'Adjust status of subjects on period change',
                    button: 'Yes, adjust status',
                    message: 'During a period change the statusses of the subject of this area will be adjusted. Are you sure?',
                },
            },
            enableWorksheet: {
                button: 'enable worksheet generation',
                message: 'Gives users the option to generate worksheets.',
                cancel: 'cancel',
                enable: 'Enable worksheet generation',
                disable: 'Disable worksheet generation',
            },
        },
        topic: {
            add: 'Add a Topic',
        },
        subject: {
            add: 'Add Learning Goals',
            rating: 'Stars',
        },
        newSubject: {
            title: 'Create a new',
            select: {
                areaColor: 'Select an Area color',
                areaIcon: 'Select an Area icon',
            },
            placeholder: 'Choose a name',
            create: 'Create {type}',
            selectFilter: {
                level: 'Choose a level',
                period: 'Choose a period',
            },
        },
        alert: {
            text: 'This curriculum does not have any Areas yet.',
            subtext: 'You can add new Areas by clicking the button above.',
        },
        total: {
            getAll: 'Got total',
        },
    },
    'user': {
        add: 'Add {item}',
        deleted_students: 'Show removed students',
        all_students: 'Show all students',
        restore: 'Restore student',
    },
    'mfa': {
        remove: {
            title: 'Multi factor authentication',
            descriptionTrue: 'Press the button to reset the MFA.',
            descriptionFalse: 'This user did not set up MFA.',
            button: 'Reset MFA',
        },
        dialog: {
            remove: {
                title: 'MFA reset',
                text: 'Are you sure that you want to reset the MFA for {name}?',
            },
        },
    },
    'level': {
        title: 'Class/Level | Classes/Levels',
        title2: 'Class/Level | Classes/Levels',
        create: 'Create a new class/level',
        placeholder: {
            name: 'Class/Level name',
            value: 'Class/Level value',
            sequence: 'Class/Level sequence',
        },
    },
    'subject_label_category': {
        all: 'All Subject categories',
        add: 'Add {item}',
        title: 'Subject category | Subject categories',
        title2: 'Subject category | Subject categories',
        create: 'Create a new Subject category',
        update: 'Update category',
        placeholder: {
            name: 'Subject category name',
        },
    },
    'subject_label': {
        all: 'All Subject tags',
        add: 'Add {item}',
        title: 'Subject tag | Subject tags',
        title2: 'Subject tag | Subject tags',
        create: 'Create a new Subject tag',
        update: 'Update Subject tag',
        placeholder: {
            name: 'Subject tag name',
        },
    },
    'period': {
        title: 'Period | Periods',
        create: 'Create new period',
        add: 'Add {item}',
        information: 'Period information',
        placeholder: {
            name: 'Period name',
            value: 'Period value',
        },
    },
    'group': {
        errors: {
            noStudents: {
                description: 'De huidige groep bevat nog geen leerlingen met doelen.',
                suggestion: 'Voeg een paar leerdoelen toe aan leerlingen in deze groep, of maak een andere selectie.',
            },
        },
        title: 'sCoolGroup | sCoolGroups',
        all: 'All Groups',
        mine: 'My Groups',
        student: 'Student | Students',
        teacher: 'Teacher | Teachers',
        guardian: 'Guardian | Guardians',
        projectPlan: 'Project plan',
        type: 'Group Type | Group Types',
        amountOfStudents: 'Amount of Students',
        profile_title: 'Group information',
        idpGroup: 'PLP Overview',
        report: 'Analysis',
        deleted_groups: 'Show removed groups',
        all_groups: 'Show all groups',
        restore: 'Restore group',
        types: {
            fixed: 'Fixedgroup for sCoolPlanner',
            class: 'Coregroup',
            coach: 'Coachgroup',
            project: 'Project',
            parnassys: 'Parnassys',
        },
        add: 'Add {item}',
        dialog: {
            select: 'Select the {type} you want to add to this group.',
            selected: 'Selected {type}',
        },
        addSubject: {
            choose: 'Choose subjects',
            chooseSubText: 'Choose subjects to add to the group',
            confirm: 'Confirm the subjects for the group',
            confirmSubText: 'Do you want to add these subjects to the group?',
            created: 'You have added the new subjects to the group',
        },
        select: 'Select group type',
        placeholder: 'Choose group',
        newFromStudents: {
            add: 'Create a new sCoolgroup',
        },
    },
    'documents': {
        title: 'MyDocuments',
        label: 'Document | Documents',
        name: 'Document name',
        connection: 'Group or student',
        object_info: {
            user: 'Student',
            group: 'Group',
        },
        connectionName: 'Name group or student',
        selectPlaceholder: 'Choose group or student',
        group: 'Group',
        student: 'Student',
    },
    'year': {
        title: 'Year | Years',
        all: 'All Years',
        create: 'Add a new Schoolyear',
        starts: 'Start',
        ends: 'Ends',
        value: 'Value',
        noCurriculum: "You don't have an active curriculum. Create a { curriculumlink } first before creating a year",
        active: 'Active',
        inactive: 'Inactive',
        information: 'Year information',
        add: 'Add {item}',
    },
    'tag': {
        title: 'School | Schools',
        all: 'All School',
        add: 'Add {item}',
        create: 'Add a new School',
        placeholder: 'Select a School',
    },
    'room': {
        title: 'Room | Rooms',
        all: 'All Rooms',
        add: 'Add room',
        placeholder: 'Select room',
        maxCapacity: 'Maximum capacity',
        color: 'Color',
        lessonTypes: 'Lesson types',
        addLessonType: 'Add lesson type',
        levels: 'Levels',
        addLevels: 'Add level',
        dialog: {
            create: 'Add new room',
            edit: 'Edit room',
            type: 'Lesson type',
            capacity: 'Capacity',
            color: 'Select the color of the new room',
            editColor: 'Edit the color of the room',
        },
        button: {
            add: 'Add',
            edit: 'Edit',
        },
    },
    'lessonType': {
        title: 'Lesson type | Lesson types',
        all: 'All lesson types',
        button: {
            add: 'Add',
            edit: 'Edit',
        },
        dialog: {
            add: 'Add lesson type',
            edit: 'Edit lesson type',
            icon: 'Lesson type icon',
        },
    },
    'school_tools': {
        parnassys: {
            title: 'Syncronize with Parnassys',
            sync_teachers_button: 'Syncronize Teachers',
            sync_parents_button: 'Syncronize Parents',
            sync_students_button: 'Syncronize Students',
            sync_message: 'Click the button to synchronize student, teacher and group information with Parnassys data.',
            sync_message_warn: 'Note: the Parnassys brin number must be entered in My School -> Settings.',
        },
    },
    'school': {
        title: 'Client | Clients',
        hide_roster: 'Digitale Klassenmap',
        myschool: 'My School',
        tools: 'Tools',
        roster: 'Roster',
        settings: 'Settings',
        lvs_settings: 'Analysis Settings',
        group_settings: 'Group Settings',
        logbook: 'logboek',
        parnassys_title: 'Parnassys',
        mfa_title: 'MFA',
        holiday: 'Holiday',
        templates: 'Templates',
        management: 'Management',
        openingHours: 'Opening Hours',
        select: 'Select client',
        all: 'All Clients',
        add: 'Add {item}',
        version: 'Version',
        mail_settings: 'Email Settings',
        create: {
            title: 'Create a New {role}',
            description: "Create a new {role} with it's own personal environment.",
            logo: {
                title: '{role} logo',
                small: '{role} logo (small)',
            },
            address: {
                title: 'Additional information',
                text: 'Fill out address and contact information.',
                address: 'Address information',
                street: 'Street',
                number: 'Number',
                add: 'Add. | Addition',
                zipcode: 'Zip code',
                city: 'City',
                contact: 'Contact information',
            },
            confirm: {
                title: 'Confirm information',
                text: 'Confirm whether all information is correct for the new {role}.',
                school: 'Client information',
                locales: {
                    title: 'Country',
                    nl: 'Netherlands',
                },
                languages: {
                    title: 'Language',
                    nl: 'Dutch',
                    en: 'English',
                    vo: 'Waldorf education',
                },
                address: 'Address information',
                contact: 'Contact information',
            },
            finished: {
                title: '{role} created',
                description: 'We have created your new {role}. You can log in with the data below. <br> The school is available with the URL for your environment.',
            },
        },
        lvs_setting: {
            areas_title: 'Areas',
            periods_title: 'Analysis Moment',
            period_create_title: 'Create new period',
            period_level_placeholder: 'Only numbers between 1 and 8',
        },
        placeholder: 'Select school type',
    },
    'rosterTemplate': {
        title: 'Template | Templates',
        add: 'Add template',
        save: 'Save template',
        createdAt: 'Created at',
        updatedAt: 'Edited at',
        start: 'Start of the week',
        dialog: {
            message: '',
            header: {
                activities: 'Activity | Activities',
                teachers: 'Teachers',
                areas: 'Areas',
                area: 'Area',
                topics: 'Topics',
                rooms: 'Rooms',
                levels: 'Levels and Groups',
                overview: 'Overview',
                finished: 'Finished',
            },
            activities: 'Activities overview',
            teachers: 'Select a teacher',
            areas: 'Select an area',
            selectedArea: 'Selected area',
            topics: 'Select a topic',
            allTopics: 'All topics',
            rooms: 'Select a room',
            levelAndGroup: 'Select a Level and a Group',
            level: 'Select a level',
            overview: 'Overview',
            addActivity: 'Add activity to timeslot',
            addBreak: 'Add recess',
            remove: 'Delete timeslot',
            create: 'Create activity',
            teacherMessage: 'When creating a lesson, you can only select a teacher for whom no lesson has yet been scheduled.',
            roomMessage: 'When creating a lesson, you can only select a room for which no lesson has yet been scheduled.',
            mandatoryMessage: 'Mandatory levels and groups will be showed in red.',
            roomFullMessage: 'To selected level/group has too many students to fit in the room | To selected levels/groups have too many students to fit in the room',
            doublePeriodMessage: 'Double periods have a blue line next to their row.',
            mandatory: {
                levels: {
                    checkbox: 'Make mandatory for selected levels',
                    overview: 'These levels are mandatory',
                },
                groups: {
                    checkbox: 'Make mandatory for selected groups',
                    overview: 'These groups are mandatory',
                },
            },
            created: 'Activity is created',
            updated: 'Activity is updated',
            createTimeslot: 'Create new timeslot',
            timeslotTitle: 'Time slot title',
            startsAt: 'Starts at',
            endsAt: 'Ends at',
            doublePeriod: 'Double period',
            doublePeriodLabel: 'Make a double period from this lesson',
            selectDoublePeriod: 'Select which time this double period should start',
        },
        recess: 'Recess',
    },
    'rosterManagement': {
        title: 'Roster Management',
        buttons: {
            create: 'Create',
            release: 'Release',
            unsafeMode: 'Turn on unsafe mode',
            safeMode: 'Turn on safe mode',
            warning: 'warning | warnings',
            error: 'error | errors',
            studentsWithoutLessons: 'Students without lessons',
        },
        filter: {
            choose: 'Choose {type}',
        },
        unsafeMode: 'You are in unsafe mode',
        roster: 'Roster',
        today: 'Today',
        dialog: {
            header: {
                selectDate: 'Select start date and duration',
                assignRoster: 'Assign roster templates',
                overview: 'Overview',
                success: 'Success',
                studentsWithoutLessons: 'Students without lessons',
            },
            startDate: 'Start date',
            amountOfWeeks: 'Amount of weeks:',
            generating: 'Roster is being generated, this can take a minute...',
            generated: 'Success, roster has been generated',
            releaseRoster: 'Release roster',
            visibleForTeachers: 'Visible for teachers',
            visibleForStudents: 'Visible for students',
            softLock: 'Soft lock',
            hardLock: 'Hard lock',
        },
    },
    'time': {
        title: 'Time',
        start: 'Start time',
        end: 'End time',
        slot: 'Time slot',
        day: 'Day',
    },
    'event': {
        title: 'Event',
        dialog: {
            create: 'Create new event',
            edit: 'Edit event',
            remove: 'Remove event',
            choose: 'Choose a lesson',
            overview: 'Lesson overview',
            studentOverview: 'Student overview',
            subjectOverview: 'Subject overview',
            title: 'Event title',
            recurring: 'Recurring event',
            frequency: 'Choose',
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            doublePeriod: 'Attention! This lesson is a double period lesson.',
            noSubjectsSelected: "You haven't selected any subject in step 1.",
            noLessonTypeSelected: "You haven't selected a lesson type in step 2.",
            noDescription: "You haven't added a description in step 2.",
        },
        edit: {
            busyWithSameLevelOrGroup: 'In group and/or level and not yet finished',
            completedWithSameLevelOrGroup: 'In group and/or level and finished',
            notSameLevelOrGroup: 'Not in group and or level, but in PLGP',
            notInPlp: 'Not in PLGP',
            totalUnique: 'Total unique students',
            makeChoice: 'Make choice',
            visibleStudents: 'This course is visible for student and therefore cannot be edited.',
            hardlocked: 'This course is before or on the hardlock date and therefore cannot be edited.',
        },
        goToThisLesson: 'I want to go to this lesson',
        lessonFull: 'This lesson is full',
        chosenLesson: 'I have chosen this lesson',
        total: 'Total invited students',
        godmode: 'Pick form all courses',
        godmodeOff: 'Back to student view',
        godmodeChosen: 'This course has been chosen for the student.',
    },
    'weekDays': {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
    },
    'holiday': {
        title: 'Holiday | Holidays',
        dialog: {
            title: 'Add new holiday',
        },
        button: {
            add: 'Add',
            edit: 'Edit',
        },
    },
    'openingHours': {
        title: 'Opening hours',
        startOfTheWeek: 'Start of the week',
        plannerStart: 'Planner start',
        noTime: 'No time selected',
        noDay: 'No day selected',
        selectedDay: 'Select day',
    },
    'area': {
        description: 'Area description',
        name: 'Area name',
    },
    'subject': {
        title: 'Learning Goal | Learning Goals',
        description: 'Description',
        rating: 'Stars',
        deleted: 'a deleted goal',
        summary: {
            title: 'Learning Goal Summary',
            chooseLevel: 'Select a level above to see the desired learning goal summary.',
            noSubjects: 'No subjects found.',
        },
        area: {
            title: 'Area | Areas',
        },
        topic: {
            title: 'Topic | Topics',
        },
        dialog: {
            finishedNote: {
                placeholder: 'Explain how the goal was completed.',
                warning: '*Attachments cannot be uploaded to goals that are currently inactive. If you have selected inactive goals please change their status first.',
            },
            achievedNote: {
                title: 'Steps',
                placeholder: 'Explain the next step how the student can achieve this goal.',
            },
            generalNote: {
                placeholder: 'Add a note',
            },
            addSubject: {
                title: 'Add Learning Goal(s)',
                select: {
                    area: 'Select Area',
                    topic: 'Select Topic',
                    goal: 'Select Learning Goal',
                    file: 'Select file',
                    placeholder: 'Select',
                },
                notFound: {
                    topic: 'No Topics found',
                    goal: 'No Learning Goals found',
                },
                mode: 'Mode',
                status: 'Status',
                description: 'Description',
                upload: 'Upload',
                addedTo: 'Added to',
            },
        },
        schedule: {
            title: 'Presents',
            present: 'Present',
            absent: 'Absent',
            tardy: 'To late',
            sick: 'Sick',
            approvedAbsence: 'Approved absence',
        },
        tab: {
            content: 'Content',
            notes: 'Notes',
            template: 'Steps',
            files: 'Files',
            messenger: 'sCoolMessenger',
            roster: 'Roster',
            treatment: 'Treatment',
            treatment_detail_page: 'Treatment',
            plan: 'Plan',
            lvs: 'Analysis',
            worksheet: 'Worksheet',
            subtitle: {
                content: 'teacher',
                template: 'student',
                files: 'teacher',
                messenger: 'teacher',
                worksheet: 'teacher',
            },
        },
    },
    'schedule': {
        title: 'Schedule | Schedules',
        subject: 'Schedule subject',
        overview: 'Subject overview',
    },
    'roles': {
        'user': 'sCoolUser | sCoolUsers',
        'child': 'Child | Children',
        'student': 'Student | Students',
        'guardian': 'Guardian | Guardians',
        'teacher': 'Teacher | Teachers',
        'specialist': 'IT Specialist | IT Specialist',
        'supervisor': 'Internal Supervisor | Internal Supervisors',
        'trainer': 'Trainer | Trainers',
        'administrator': 'Administrator | Administrators',
        'root': 'Super Administrator | Super Administrators',
        'board-member': 'Roster Maker | Roster Makers',
    },
    'teacher': {
        add: 'Add Teacher | Add Teachers',
        subject: {
            title: 'Areas belonging to this teacher',
            dialog: {
                select: {
                    title: 'All areas',
                    subTitle: 'Select areas to add to the teacher',
                },
                confirm: {
                    title: 'Confirm the selected areas for the teachers',
                    subTitle: 'Please confirm if you want to add these areas to the teacher',
                },
                finished: {
                    title: 'Done!',
                    subTitle: 'You have added new areas to the teacher',
                },
            },
            noSubjects: 'No specific areas for this teacher',
        },
    },
    'student': {
        add: 'Add Student | Add Students',
        redo_level: 'Also redo different levels',
        scoolfolio: 'sCoolFolio',
        area: 'Area',
        portfolio_archive: 'Portfolio archive',
        archive: {
            download_to_archive: 'Download portfolio to archive',
            download_to_local: 'Download portfolio to computer',
        },
    },
    'table': {
        found: '{total} {name} found',
        perPage: '{name} per page:',
        noData: 'No data available',
        noStep: 'No steps available',
        maxCapacity: 'Max capacity',
        type: 'Type',
    },
    'errors': {
        loading: {
            description: 'There was a problem loading the required information.',
            suggestion: 'Please try again later.',
        },
        notFound: {
            description: 'The page you were looking for could not be found.',
            suggestion: '404',
            url: 'Please check the url for any typos',
            error: '404 ERROR.',
            oops: 'Oops :(',
            noSchool: 'The school you are trying to reach does not exist.',
            or: 'or',
            contact: 'contact us via',
            signUp: 'to sign up with sCoolTool!',
        },
    },
    'idp': {
        title: 'sCoolTracker',
        titleShort: 'sCoolTracker',
        completedTotal: '{completed} of {total} learning goals done',
        add: 'Add PLGP',
        add_skill_set: 'Add skill set',
        current: 'Active PLGP',
        future: 'Next PLGP',
        dismissed: 'Not Applicable',
        active: 'Active',
        expandTopic: 'Open',
        collapseTopic: 'Close',
        filter: 'Filter',
        project: 'Project',
        generate: {
            title: 'Generate PLGP',
            titleWithName: 'Generate PLP of {name}',
            message: 'Click on the button to get an upcoming PLP for everyone.',
            attention: '* Please note, this also updates the current PLGP',
            warning: 'It can take 5 minutes for everyone to see his upcoming PLGP.',
            button: 'Generate',
        },
        synchronize: {
            title: 'Synchronize goalsets',
            message: 'Click on the button to get an upcoming goalsets for everyone.',
            warning: 'It can take 5 minutes for everyone to see his upcoming goalsets',
            button: 'Synchronize',
        },
        delete: {
            title: 'Delete subjects from PLGP',
            message: 'Click on the button to delete the current or upcoming PLP for everyone.',
            warning: 'Processing time max. 5 minutes.',
            button: 'Subject status {status}',
        },
        status: {
            busyHighlightedOld: 'Current, Highlighted & Old',
            highlighted: '{highlighted} | Highlighted',
            busy: '{current} | Current',
            old: '{old} | Old',
            inactive: '{inactive} | Inactive',
            closed: '{closed} | Closed',
            finished: '{finished} | Completed',
            future: '{future} | Future',
            dismissed: '{dismissed} | N/A',
        },
        treatment: {
            purple: '{purple} | Purple',
            teal: '{teal} | Teal',
            blue: '{blue} | Blue',
            yellow: '{yellow} | Yellow',
            burgundy: '{burgundy} | Burgundy',
            pink: '{pink} | Pink',
        },
        reset: {
            warning: 'This can take up to 30 minutes.',
        },
        errors: {
            noGoals: {
                description: 'Your current Personal Learning Goals Plan does not contain any goals..',
                suggestion: 'Try adding some learning goals or make a different selection.',
            },
        },
    },
    'progress': {
        title: 'Personal',
        placeholder: 'Add here your own text...',
        label: {
            title: 'label | labels',
            header: 'This is you',
            new: 'New label',
        },
        interest: {
            title: 'interest | interests',
            header: 'Personal',
            new: 'New interest',
        },
        photoalbum: {
            title: 'photo | photos',
            header: 'Photoalbum',
        },
        skill: {
            title: 'skill | skills',
            header: 'Skills',
            goals: 'Goals',
            new: 'New skill name',
            general: 'General',
        },
        result: {
            title: 'result | results',
            header: 'Results',
            table: {
                header: {
                    name: 'Name',
                    description: 'Description',
                },
            },
        },
        dialog: {
            title: 'Update check',
            subtitle: 'Are you sure you want to update the {item}?',
            uploadFile: 'Upload file',
            selectFile: 'Select file',
            selected: 'selected',
        },
        button: {
            add: 'Add {item}',
            edit: 'Edit {item}',
        },
    },
    'portfolio': {
        title: 'sCoolDrive',
        no_result: 'No files were found',
        select: {
            area: 'Choose Area',
            topic: 'Choose Topic',
        },
        dialog: {
            title: 'Upload to sCoolDrive',
            addGoal: 'Upload a file to a learning goal',
            addGoalDescription: 'Portfolio student',
            addOther: 'sCoolPlan: Upload information about the student',
            addOtherDescription: 'File (only visible for teachers)',
            scoolPlan: 'sCoolPlan',
            placeholder: {
                description: 'Description',
            },
            message: 'You can upload files up to 250MB',
            fileSizeExceededTitle: 'File size limit exceeded.',
            fileSizeExceededMessage: 'The file you are trying to upload exceeds the 250MB limit. Please try compressing the file and re-uploading.',
        },
        skills: {
            noValidCategories: "All skill sets have been added to this student's portfolio. You can create an additional skill set at the skill sets page.",
            textSkillSets: 'Skill Sets',
        },
        showOther: 'sCoolPlan files',
        document: 'document',
    },
    'actions': {
        notObligate: 'Make not mandatory',
        obligate: 'Make mandatory',
        delete: 'Delete | Deleted',
        add: 'Add | Added',
        edit: 'Edit | Edited',
        cancel: 'Cancel | Canceled',
        save: 'Save | Saved',
        back: 'Back',
        next: 'Next',
        close: 'Close',
        markAsSaved: 'Mark as saved',
        markAsAchieved: 'Mark as completed',
        markAsNotAchieved: 'Mark as not completed',
        markAsFinished: 'Finished',
        markAsNotFinished: 'Not Finished',
        needHelp: 'Need help',
        dontNeedHelp: 'No help needed',
        assisted: 'Student assisted',
        markAsBusy: 'Mark as busy',
        addAttachment: 'Add attachment',
        send: 'Send',
        download: 'Download',
        upload: 'Upload',
        ok: 'Ok',
        reset: 'Reset',
        saveAndUpload: 'Save and upload',
        getTotal: 'Get total',
    },
    'chat': {
        title: 'Chat | Chats',
        subject: 'Subject | Subjects',
        message: 'Message | sCoolMessenger',
        attendees: 'Attendees',
        messageTo: 'Send message to ...',
        send: 'Send',
        files: 'Files',
        add: 'Add user to chat',
        deleted: 'This message was removed',
        regarding: 'Chat regarding',
        group: {
            title: 'Group | Groups',
            studentGuardian: 'Student and Guardian (External)',
            guardiansOnly: 'Guardians only (External)',
            teachersOnly: 'Teachers only',
        },
    },
    'levels': {
        all: 'All Classes/Levels',
        download: {
            button: 'Download report',
            title: 'Download report',
            description: 'The report is currently being prepared...',
        },
        toggleActive: 'Show active topics only',
        add: 'Add {item}',
        topics: 'Topics',
        grade: 'Class/Level',
        changeGrade: 'Change class/level',
        room: 'Room',
        dialog: {
            title: 'Edit',
        },
    },
    // TODO: Stefano translate pls
    'projects': {
        navigation: {
            title: 'sCoolProjects',
            all: 'Projects',
            mine: 'My Projects',
        },
        select: {
            placeholder: 'Select a project',
        },
        table: {
            name: 'Name',
            description: 'Description',
            subjects: 'Goals',
        },
        tabs: {
            subjects: 'Learning Goals',
            media: 'Media',
            notes: 'Notes',
            project_plan: 'Project Plan',
            files: 'Bestanden',
            messenger: 'Chat',
        },
        dialog: {
            steps: {
                info: 'Project Information',
                subjects: 'Subjects',
                subjects_confirm: 'Leerdoelen bevestigen',
            },
            info: {
                title: 'Create a new Goal Set',
                name: 'Name',
                description: 'Description',
            },
            subjects: {
                title: 'Leerdoelen toevoegen',
            },
            subjects_confirm: {
                title: 'Leerdoelen bevestigen',
            },
            create: 'Create Project',
        },
        description: 'Omschrijving',
        title: 'Project | Projects',
        all: 'All projects',
        mine: 'My projects',
        add: 'Add {item}',
        no_project_alert_text: 'You are not yet connected to a project.',
        no_project_alert_subtext: 'Go to the profile page to link it.',
    },
    'student_plan': {
        // TODO @FRED
        // FIXME
        template: {
            title_placeholder: 'Step name',
            title_label: 'Name',
            name_placeholder: 'Template Name',
            name_label: 'Template Name',
            add_step: 'Add Step',
            add_lvs: 'Add LVS',
            add_subjects: 'Add subjects',
            select: 'Select template (optional)',
            quill: 'Write the content of the paragraph here',
            all: 'All Templates',
            create: 'Create Template',
            cancel: 'Cancel',
            title: 'Template | Templates',
            sidebar: 'Plan Templates',
        },
        table: {
            title: 'Title',
            description: 'Description',
            start_at: 'Start Date',
            end_at: 'End Date',
            status: 'Status',
        },
        dialog: {
            steps: {
                one: 'Basic Info',
                two: 'Text',
                three: 'Files',
                teachers: 'Teachers',
            },
            one: {
                title: 'Create a new Plan | Update Plan',
                name: 'Name',
                description: 'Description',
                quill: 'Enter a description about this document',
            },
            two: {
                title: 'Leerdoelen toevoegen',
            },
            three: {
                title: 'Leerdoelen bevestigen',
            },
            one_student: {
                title: 'Create a new Plan | Update Plan',
                name: 'Name',
                description: 'Description',
                quill: 'Enter a description about this document',
            },
            two_student: {
                title: 'Leerdoelen toevoegen',
            },
            three_student: {
                title: 'Leerdoelen bevestigen',
            },
            save: 'Create Plan | Update Plan',
            start_date: 'Select start date',
            end_date: 'Select end date',
            plan_status: 'Select plan status',
            is_visible_to_parents: 'Share with parents',
            is_visible_for_teachers: 'Share with all teachers',
            select_teachers: 'Select teacher',
            create: 'Create template',
        },
        school_settings: {
            status_title: 'Plan Status',
            dialog: {
                status_label: 'Status',
                status_placeholder: 'Status',
                title: 'New Plan Status',
                create: 'Create',
            },
        },
        description: 'Omschrijving',
        title_group: 'Plan | Plans',
        title: 'Plan | Plans',
        all: 'All plans',
        add: 'Add plan',
        add_student: 'Add plan',
    },
    'template': {
        placeholder: 'Steps text',
    },
    'help': {
        title: 'Helpdesk',
    },
    'facts': {
        title: 'sCoolFacts',
    },
    'stats': {
        title: 'sCoolStats',
    },
    'feature': {
        title: 'New Features',
    },
    'starts': {
        title: 'Start date',
    },
    'absence': {
        title: 'Symbiosis arrangement',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc imperdiet faucibus metus eget vestibulum.',
        download: 'Wanneer je gebruik maakt van de Symbioseregeling, Download hier de statistieken',
    },
    'reset': {
        title: 'Reset periods and levels',
        levels: {
            title: 'levels',
            text: 'Click on the button to restore all deviating levels for all sub-areas and all students to the main level',
        },
        periods: {
            title: 'periods',
            text: 'Click on the button to reset all deviating periods for all students to the current standard period',
        },
    },
    'ends': {
        title: 'End date',
    },
    'value': {
        title: 'Excel',
    },
    'sequence': {
        title: 'Sequence',
    },
    'address': {
        country: 'Country',
        placeholder: 'Select country',
    },
    'language': {
        placeholder: 'Select language',
    },
    'userImportErrors': {
        101: 'A Coach Group does not exist',
        102: 'A Core Group does not exist',
        201: 'Required excel fields are empty',
        1000: 'An unknown error occurred',
    },
    'component': {
        selectFilter: {
            placeholder: 'Choose',
            level: 'Level',
            subject_label: 'tags',
            period: 'Period',
            block: 'Block',
            group: 'Group',
        },
    },
    'downloadDialog': {
        header: {
            title: 'Download PDF',
            description: 'Select areas to include in the PDF and download.',
        },
        select: {
            label: 'Select areas',
        },
    },
    'removeDialog': {
        header: {
            title: 'Remove learning goals from PLP',
            description: 'Selecteer areas to remove.',
        },
        button: {
            select: 'Select all learning goals',
            removeAll: 'Remove all',
            removeInProgress: 'Remove in progress ',
            removeNew: 'Remove new',
            removeOld: 'Remove old',
        },
        successMessage: 'The selected learning have been removed.',
    },
    'createDialog': {
        header: {
            choose: 'Choose',
            import: 'Import',
            export: 'Export',
            profile: 'Profile',
            relationship: 'Relationship',
            confirm: 'Confirm',
            finished: 'Finished',
            explore: 'Add students',
            create: 'Group information',
            address: 'Address',
            select: 'Select',
            merge: 'Add Parnassys groups (optional)',
            name: 'Name',
        },
        choose: {
            title: 'Create a {role}',
            text: 'Import a {role} from a file or create a new profile',
            options: {
                one: {
                    title: 'Upload .xsl file',
                    text: 'For one or more {role}',
                },
                two: {
                    title: 'Create {role} profile',
                    text: 'For a single {role}',
                },
            },
        },
        profile: {
            title: 'Create new {role} profile',
            text: 'Fill out the form to create a new profile',
            upload: 'Upload a picture',
            click: 'Click here',
        },
        import: {
            title: 'Import {role}',
            text: 'Upload an existing Excel file',
            browse: 'Click to browse and upload a {role}',
        },
        relationship: {
            title: 'Guardians',
            text: 'Select an existing {role} or a new one.',
            existing: 'Choose an existing {role}',
            create: 'Create a new {role} profile',
            chosen: 'Chosen {role}',
            or: 'or',
            save: 'Save {role}',
            placeholder: 'Choose {role}',
        },
        confirm: {
            title: 'Confirm information',
            text: 'Confirm whether all information is correct for the new {role}.',
            selected: 'Selected',
        },
        select: {
            curriculum: {
                title: 'Active Curriculum',
                text: 'Select learning goals from the curriculum to add to  the PLGP.',
                confirmTitle: 'Confirm the learning goals for the PLGP',
                confirmText: 'Please confirm if you want to add these learning goals to the PLGP.',
                idpType: 'To which PLGP do you want to add these learning goals?',
                created: 'You have added new learning goals to the PLGP',
            },
        },
        finished: {
            title: 'Done!',
            text: 'You have created a new {role}',
            password: 'This new user can log in with the following password:',
            imported: {
                part1: 'You have imported',
                part2: 'new {role}.',
            },
            updated: '{role} have been updated.',
            failed: {
                title: 'Partly succeeded',
                row: 'Row',
                email: 'Email',
                field: 'Field',
                missing_email: 'Unknown',
                explainer: 'It concerns the following',
                errors: {
                    email: 'Email',
                    dob: 'Date of birth',
                    first_name: 'Firstname',
                    last_name: 'Lastname',
                },
                part1: "We couldn't upload",
                part2: '{role}',
            },
        },
        create: {
            title: 'Create new {role}',
            text: 'Attach users to a {role}.',
            type: 'Type | Types',
            placeholder: 'Select {role} type',
        },
        explore: {
            title: 'Explore',
            text: 'View the information and confirm the {role}.',
        },
        merge: {
            title: 'Parnassys groups (optional)',
            text: 'Attach a Parnassys group to a {role}.',
        },
    },
    'dialogOptions': {
        sync_warning: 'Caution! Are you sure you that you want to synchronize with parnassys?. This action can not be reversed.',
        sync_warning_goals_sets: 'Caution! Are you sure that you want to synchronize goalsets? This action can not be reversed.',
        init_warning: 'Are you sure that you want to initialize parnassys?',
        item: {
            plan: 'plan',
            project: 'project',
            user: 'user',
            student: 'student',
            students: 'students',
            progress: 'Progress',
            teacher: 'teacher',
            guardian: 'guardian',
            area: 'area',
            message: 'message',
            subject: 'learning goal',
            subjects: 'learning goals',
            treatment: 'Treatment',
            topic: 'topic',
            curriculum: 'curriculum',
            group: 'group',
            level: 'class/level',
            period: 'period',
            file: 'file',
            template: 'template',
            step: 'step',
            year: 'year',
            tag: 'school',
            school: 'client',
            note: 'note',
            room: 'room',
            lessonType: 'Lesson Type',
            lesson: 'lesson',
            activity: 'Activity',
            timeslot: 'Time slot',
            helpAndFinished: 'help and finished status',
        },
        success: 'Success!',
        confirmation: 'Confirmation',
        forbidden: 'No access',
        reset: 'Are you sure that you want to reset {item}?',
        delete: 'Are you sure that you want to delete this {item}? | Are you sure that you want to delete these {item}?',
        deletePermanently: 'Are you sure that you want to permanently delete this {item}?',
        deleteMany: 'Are you sure that you want to delete {item}?',
        deleteMultiple: 'Are you sure that you want to delete {amount} {item}?',
        deleteFromGroup: 'Are you sure that you want to remove this {item} from the group?',
        notObligate: 'Are you sure that you want to make this lesson not mandatory for this {item}? | Are you sure that you want to make this lesson not mandatory for these {item}?',
        obligate: 'Are you sure that you want to make this lesson mandatory for this {item}? | Are you sure that you want to make this lesson mandatory for these {item}?',
        resetPeriods: 'Pay attention! You are going to reset all deviating periods to the basics. This promotion cannot be undone!',
        resetLevels: 'Pay attention! You are about to reset the levels for everyone',
        lesson: 'Are you sure you want to go to this {item}?',
        save: '{item} is saved',
        update: 'Are you sure you want to update this {item}? | Are you sure you want to update these {item}?',
        export: 'Are you sure you want to export this {item}? | Are you sure you want to export these {item}?',
        button: {
            reset: 'Reset',
            delete: 'Delete',
            cancel: 'Cancel',
            ok: 'Ok',
            yes: 'Yes',
        },
        switchedVersion: 'The school is changed to version {version}. The page must be reloaded to apply the changes.',
        deleteBusyPLP: 'Pay attention! This action removes all goals with the current status, even if something has already been added by teachers / students. Old and highlighted goals remain in the PLP. This action is irreversible.',
        deleteHighlightedPLP: 'Pay attention! This action removes all goals with the highlighted status, even if something has already been added by teachers / students. Current and old goals remain in the PLP. This action is irreversible.',
        deleteOldPLP: 'Pay attention! This action removes all goals with the old status, even if something has already been added by teachers / students. Highlighted and current goals remain in the PLP. This action is irreversible.',
        deleteCurrentPLP: 'Pay attention! This action removes the current PLPs from students. All goals, including current, old and highlighted goals, will be deleted, even if something has already been added by teachers / students. This action is irreversible.',
        deleteFuturePLP: 'Pay attention! This action removes upcoming PLPs from students. All goals in an upcoming PLP will be deleted, even if something has already been added by teachers / students. This action is irreversible.',
    },
    'swapDialog': {
        title: 'Swap topic',
        topic: 'Topic Name',
        select: {
            area: 'Select Area',
            topic: 'Select Topic',
        },
        placeholder: 'Choose one',
        swap: 'Swap',
    },
    'importSubjects': {
        title: 'Import Area, Topics and/or Learning Goals',
        text: 'Import an Area/Topic/Learning goals from a file.',
    },
    'lvs': {
        title: 'Analysis Settings',
        text: 'Select a period (middle or end) and click the button to generate the topic statuses. Note, this will overwrite previous generated statuses for students.',
        textwarning: 'This can take up to 30 minutes.',
        select: {
            placeholder: 'Select a period',
            group_placeholder: 'Select a group',
            middle: 'Middle',
            end: 'End',
            start: 'Start',
        },
        dialog: {
            confirm: {
                text: 'Are you sure you want to generate topic statuses of the students? Note, this will overwrite previous generated statuses for students.',
            },
            success: {
                text: 'Analysis of students is currently being generated. This can take up to 30 minutes.',
            },
        },
        action: {
            run: 'Generate',
        },
        treatment: {
            title: 'LVS Areas',
            area: 'Area',
            description: 'Notes',
        },
    },
    'snackbar': {
        actions: {
            chat: 'Chat',
            roadmap: 'Roadmap',
            deselect: 'Deselect',
            reset_statuses: 'Reset status',
        },
    },
    'summary': {
        title: 'Learning Goals Overview',
        clearStudentStatuses: 'Reset help and finished status',
        status: 'Change status Learning Goal',
        description: 'Steps',
        message: 'Chat abouw Learning Goals',
        placeholder: 'Actions',
        view: 'Note about this student',
        open: 'Open profile',
        error: 'The selected filter has no students.',
        treatmentAdd: 'Add treatment',
        patience: 'One moment please.',
        support: 'Try again or open a ticket at sCoolHelp.',
        dialog: {
            status: {
                title: 'Adjust status of Learning Goal(s)',
                text: 'Adjust status for {length} Learning Goal(s)',
                takingTooLong: 'We are busy adjusting the status.',
                alert: {
                    failed: {
                        title: 'Adjusting the status takes a bit longer than normal. Something may have gone ',
                    },
                    submitted: {
                        title: 'Status has been adjusted for {length} Learning Goal(s).',
                    },
                },
            },
            statusFinalized: {
                title: 'Adjust rating',
                text: 'Adjust rating for {length} Learning Goal(s)',
                takingTooLong: 'We are busy adjusting the rating.',
                alert: {
                    failed: {
                        title: 'Adjusting the rating takes a bit longer than normal. Something may have gone ',
                    },
                    submitted: {
                        title: 'Rating has been adjusted for {length} Learning Goal(s).',
                    },
                },
            },
            message: {
                title: 'Place message',
                text: 'Place messages with selected students who have this Learning Goal as Highlighted.',
                placeholder: 'Message',
                takingTooLong: 'We are busy with placing your messages.',
                send: 'Send',
                alert: {
                    failed: {
                        title: 'Placing your messages takes a bit longer than normal. Something may have gone wrong.',
                    },
                    notSelected: {
                        title: 'One or more of these goals does not have a yellow status, so sCoolMessenger does not work.',
                        text: 'Adjust these goals to a yellow status to send an instant message.',
                    },
                    submitted: 'There are {length} new messages placed for your selection.',
                },
            },
            description: {
                title: 'Next step',
                text: 'Choose on the right, by pressing on the three dots a per-selected step or write a new one for the {length} learning goal(s)',
                header: 'Steps',
                takingTooLong: 'We are busy adjusting the next step.',
                placeholder: 'Explain what the student his next step is.',
                alert: {
                    failed: 'Adjusting the next step takes a bit longer than normal. Something may have gone wrong.',
                    submitted: 'The next step is adjusted for {length} goals.',
                },
            },
        },
    },
    'steps': {
        title: 'Step | Steps',
        placeholder: 'Steps text',
    },
    'select_filter': {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
    },
    'rosterAudits': {
        activity: {
            missing: 'This timeslot has no activities yet.',
        },
        event: {
            missing: 'This date time slot has no lessons yet.',
        },
        teacher: {
            absent: '{name} is not present for this time slot.',
            contract: 'The timeslot takes place outside of {name} contract hours on {day}.',
            occupied: '{name} is already planned for something else on this time slot.',
            vacation: '{name} is not available because there has been released.',
        },
        group: {
            occupied: 'The group "{name}" has been linked to several activities.',
            unassigned: 'Group "{name}" is not linked to anything yet.',
            missing: 'No groups have yet been invited to an activity.',
            recess: 'Group "{name}" has recess and a lesson at the same time.',
        },
        level: {
            occupied: 'The level "{name}"has been linked to multiple activities.',
            unassigned: 'Level "{name}"is not linked to anything yet.',
            missing: 'No levels have yet been invited to an activity.',
            recess: 'Level "{name}" has recess and a lesson at the same time.',
        },
        room: {
            occupied: 'The room "{name}" has been assigned to multiple activities.',
        },
    },
    'logs': {
        title: 'Logs',
        fetch: 'Fetch logs',
    },
    'yes': 'Yes',
    'no': 'No',
    'by': 'by',
    'on': 'on',
    'quillEditor': {
        placeholder: 'Insert text here ...',
    },
    'date': {
        title: 'Date',
    },
    'finished': {
        comment: 'Comment',
        by_teacher: 'By',
        finished_on: 'on',
    },
    'uploadNoteDialog': {
        header: 'Upload note to sCooldrive',
        placeholder: 'Title description',
    },
    'settings': {
        student: 'Student settings',
        guardian: 'Guardian settings',
        has_roster: {
            title: 'Send Autoplanner email when roster is empty',
            description: 'When the roster is empty send an autoplanner e-mail nonetheless',
        },
        plp: {
            title: 'Set goal to yellow',
            description: 'Students can set the goal in yellow in the PLP',
        },
        guardian_can_see_student_scooltracker: {
            title: 'Determine if you hide the sCoolTracker tab for parents',
            description: "Parents can view a student's sCoolTracker tab",
        },
        guardian_can_see_student_this_is_me: {
            title: 'Determine if you hide the Personal tab for parents',
            description: "Parents can view a student's Personal tab",
        },
        guardian_can_see_student_portfolio: {
            title: 'Determine if you hide the sCoolDrive tab for parents',
            description: "Parents can view a student's sCoolDrive tab",
        },
        guardian_can_see_student_finished: {
            title: 'Determine if you hide the Finished tab for parents',
            description: "Parents can view a student's Finished tab",
        },
        guardian_can_see_student_profile: {
            title: 'Determine if you hide the Profile tab for parents',
            description: "Parents can view a student's Profile tab",
        },
        guardian_can_see_student_notes: {
            title: 'Determine if you hide the Notes tab for parents',
            description: "Parents can view a student's Notes tab",
        },
        guardian_can_see_student_roster: {
            title: 'Determine if you hide the Roster tab for parents',
            description: "Parents can view a student's Roster tab",
        },
        guardian_can_use_chat_functions: {
            title: 'Determine if you turn off the chat function for parents',
            description: "Parents can use the chat functions at PLP and at a student's sCoolMessenger",
        },
        guardian_can_see_student_lvs: {
            title: 'Determining whether to show the Analysis tab on a student to parents',
            description: 'Parent can see the Analysis tab of a student',
        },
        hide_my_roster: {
            title: 'Digitale Klassenmap',
            description: 'Zet deze optie aan om de Digitale Klassenmap te activeren. Onderdeel MijnRooster zal dan niet meer zichtbaar zijn voor leraren en leerlingen.',
        },
        parnassys: {
            brin_number_title: 'Brin Number',
            brin_number_subtitle: 'Enter the school number here',
            guardians_title: 'Sync Parents',
            guardians_subtitle: 'If this setting is on, parents will be synchronized from Parnassys to My Learning Line.',
            teachers_title: 'Sync Teachers',
            teachers_subtitle: 'If this setting is on, teachers will be synced from Parnassys in My Learning Line.',
            automatic_sync_students_title: 'Automatic Sync Students',
            automatic_sync_students_subtitle: 'When turned on, students will be automatically sync every day at 7:00 AM',
            automatic_sync_teachers_title: 'Automatic Sync Teachers',
            automatic_sync_teachers_subtitle: 'When turned on, teachers will be automatically sync every day at 7:00 AM',
            automatic_sync_guardians_title: 'Automatic Sync Guardians',
            automatic_sync_guardians_subtitle: 'When turned on, guardians will be automatically sync every day at 7:00 AM',
        },
        mfa: {
            teachers_title: 'MFA teachers',
            teachers_subtitle: 'If this setting is on, teachers will need MFA to login.',
            students_title: 'MFA students',
            students_subtitle: 'If this setting is on, students will need MFA to login',
            guardians_title: 'MFA parents',
            guardians_subtitle: 'If this setting is on, parents will need MFA to login',
        },
        group: {
            is_visible_for_students: 'Visible for students',
            new_group_type: 'New Group Type',
            delete_error: 'Unable To Delete Group Type',
        },
    },
    'idp_pdf_download': {
        no_students_found: 'Something went wrong while retrieving students.',
        will_be_sent_by_email: 'The student booklets are generated and emailed to you as soon as they are ready. This may take several minutes.',
        download_successful: 'The student booklet will automatically open in a new tab',
    },
    'select': {
        project: {
            placeholder: 'Choose a project',
        },
    },
    'skill_set': {
        add: 'Add Skill Set',
        delete: 'Delete Skill Set',
        create: 'Create Skill Set',
        create_button: 'Create',
        edit: 'Edit Skill Set',
        title: 'Skill Sets',
        edit_name: 'Enter the new skill set name',
        dialog: {
            select_placeholder: 'Select Skillset',
            select_label: 'Skillset',
            delete_category_warning: 'Are you sure you want to delete this skill set?',
        },
        alert: {
            text: 'No skills have been created yet.',
            subtext: 'You can add one by pressing the button.',
            delete: 'Are you sure you want to delete this?',
        },
        add_skill: 'Add Skill',
        name_placeholder: 'Type a skill set name',
    },
    'subjectSelect': {
        areaText: 'Select an area',
        topicText: 'Select a topic',
    },
    'parnassys': {
        navigation_title: 'Parnassys',
        table: {
            results_found: 'user | users',
            headers: {
                name: 'Name',
                roles: 'Roles',
                parnassys_id: 'Parnassys ID',
            },
        },
        dialog: {
            no_users_found: 'We could not find any users. Try with typing a different name.',
            step_1: {
                header: 'User data',
                title: 'User to be linked',
                subtitle: 'Enter the name of the user you want to link to parnassys',
                find: 'Find User',
                label: 'Select student',
                placeholder: 'Student',
            },
            step_2: {
                header: 'User selection',
                title: 'User to be linked',
                subtitle: 'Enter the name of the user you want to link to parnassys',
                success: 'User was successfully linked',
            },
        },
    },
    'legend': {
        title: 'Legend',
        description: 'Subject has steps.',
        open: 'Open subject in dialog.',
        steps: '(un) completed steps.',
        project: 'Subject is linked to project.',
        help: 'Student has requested help.',
        finished: 'Student marked subject as finished.',
        prio: 'This subject has prioriry.',
        descriptions: {
            busy: "Subject is offered in the current period. The student hasn't received an instruction or didn't start this subject.",
            highlighted: 'Student is working on this subject.',
            old: "Subject from previous period and/or level. The student didn't work on this subject.",
            inactive: 'Subject has not been assigned to student.',
            closed: "Subject hasn't been completed, but is not offered anymore.",
            finished: 'Subject has been completed.',
            future: 'This subject is ready for a student for the next period.',
            dismissed: 'Subject has been manually dissmissed by teacher.',
        },
    },
    'navigationCard': {
        student: {
            schoolTracker: 'View the active, completed and achieved learning goals on the Personal Learning Plan here',
            thisIsMe: 'View personal development and skills here',
            portfolio: 'Collect and view personal documents here',
            profile: 'View personal information here, update passwords, see which parents are linked, and which group(s) the student is a member of',
            messages: 'Read and send messages between student, parent(s) and teachers here',
            notes: 'View notes about development, attitude towards work, and/or the learning process here',
            treatment: 'View or describe support for strengthening development, attitude towards work and/or the learning process',
            plan_group: 'View and make evaluations, action plans, growth documents, OPPs, etc',
            plan: 'View and make evaluations, action plans, growth documents, OPPs, etc',
            levels: 'Analyze whether the supply (PLP) matches the results (PLP and LVS)',
            finished: 'View the overview of the achieved learning objectives here',
            roster: 'View the current weekly schedule or choose classes for the upcoming weekly schedule',
        },
        group: {
            profile: 'View and change the name of the group, linked teachers and students and link a goal set.',
            files: 'Piece of text left',
            steps: 'Piece of text left',
            messages: 'Read and send messages to the members of the group.',
            notes: 'Read and take notes about the group.',
            audit: "View the group's log.",
            studentOverview: 'View the number of statuses (blue, yellow, orange, green, red, gray) of the group per student. See in numbers how the student is doing compared to the other group members. Filter the overview by main area, sub-area, level and/or period. Then generate a Learning Outcome Overview to perform actions.',
            curriculum: 'View the number of active learning objectives per main and sub-area of the group members. See which learning goals you still need to organize as a teacher. Then generate a Learning Outcome Overview to perform actions.',
            projectPlan: 'View the plan of the linked Goal Set (optional).',
            report: 'View and enter the results of the LVS test to make a group-level analysis. These results also make it possible to make an analysis for the student (optional).',
            titles: {
                profile: 'GroupProfile',
                messages: 'Group Chat',
                notes: 'Group Notes',
                plan: 'Goal SetPlan',
                studentOverview: 'PLP Overview students',
                curriculum: 'PLP Overview teacher',
                report: 'Group Analysis',
            },
        },
        project: {
            subjects: 'Add the learning objectives from the curriculum to the goal set',
            notes: 'Describe the content of the goal set and/or provide information to the teacher about the goal set/theme.',
            projectPlan: 'Describe the steps and/or assignments for the student to get started with the goal set (optional)',
            media: 'Save files, documents and media that match the target set/theme (optional)',
            files: 'Piece of text left',
            messenger: 'Communicate with students and/or teachers about the goal set/theme.',
            titles: {
                messenger: 'Target SetChat',
            },
        },
    },
    'worksheet': {
        title: 'Worksheet form',
        newWorksheet: 'New worksheet',
        openWorksheet: 'Open worksheet',
        downloadWorksheet: 'Download worksheet',
        succesMessage: 'The worksheet is generated',
        sumOptions: 'Sum options',
        reviewOptions: 'review opties',
        addendum: 'additional information',
    },
    'app_offline_title': 'Application Offline',
    'app_offline_subtitle': 'This application is currently unavailable. Please try to reload the page.',
    'app_offline_button_reload': 'Reload Page',
    'choose_area': 'Choose Area',
    'choose_topic': 'Choose Topic',
    'status': 'Status',
    'insights': 'Insights',
    'student_overview': 'Student Overview',
    'prioritise': 'Prioritise',
    'deprioritise': 'Deprioritise',
    'prioritised': 'MyPriority',
    'no_schools_connected': 'No schools connected',
    'admin_dashboard_description': 'This is the dashboard of the MyLeerlijn admin portal. Here you can manage accounts and schools.',
    'access_to_all_schools': 'Access to all schools',
    'parnassys_name': 'Parnassys name',
    'reset_mfa': 'Reset 2FA code for user',
    'is_primary': 'Is primary',
    'user_text': 'User',
    'group_text': 'Group',
    'student_text': 'Student',
    'Remove {item}': 'Remove {item}',
    'Update Available': 'Update Available',
    'A new release has been made available.': 'A new release has been made available.',
    'Working with an old version may cause unexpected issues.': 'Working with an old version may cause unexpected issues.',
    'Refresh Application': 'Refresh Application',
    'hide notification': 'hide notification',
    'Manually Refresh': 'Manually Refresh',
    'When done with your work please close this window; or, refresh the page by using CTRL + F5 on a Windows device or CMD + R on an iOS (Apple) device.': 'When done with your work please close this window; or, refresh the page by using CTRL + F5 on a Windows device or CMD + R on an iOS (Apple) device.',
    'Close': 'Close',
    'The maximum file size is 7MB': 'The maximum file size is 7MB',
    'The maximum file size is exceeded': 'The maximum file size is exceeded',
    'Lesson plan generator': 'Lesson plan generator',
    'Amount of areas': 'Amount of areas',
    'Areas': 'Areas',
    'Tag category': 'Tag category',
    'Graduation profile': 'Graduation profile',
    'Graduation profiles': 'Graduation profiles',
    'Area': 'Area',
    'Amount of topics': 'Amount of topics',
    'Add graduation profile': 'Add graduation profile',
    'Create graduation profile': 'Create graduation profile',
    'Edit graduation profile': 'Edit graduation profile',
    'Topics': 'Topics',
    'Topic': 'Topic',
    'Tag categories': 'Tag categories',
    'Select a category': 'Select a category',
    'All tag categories': 'All tag categories',
    'All graduation profiles': 'All graduation profiles',
    'Group actions': 'Group actions',
    'Assign graduation profile': 'Assign graduation profile',
    'Select all': 'Select all',
    'Unselect all': 'Unselect all',
    'Select graduation profile': 'Select graduation profile',
    'Select students': 'Select students',
    'Select PLP': 'Select PLP',
    'Attach': 'Attach',
    'Students': 'Students',
    'Action completed': 'Action completed',
    'Action completed successfully': 'Action completed successfully',
    'Attach graduation profile': 'Attach graduation profile',
    'A graduation profile contains all areas and topics that are part of the graduation profile. By attaching a profile to one or more students, all areas are asigned at once.': 'A graduation profile contains all areas and topics that are part of the graduation profile. By attaching a profile to one or more students, all areas are assigned at once.',
    'Actions': 'Actions',
    'Below you find a list of actions that can be executed for a group.': 'Below you find a list of actions that can be executed for a group.',
    'The student booklets are generated and emailed to you as soon as they are ready. This may take several minutes.': 'The student booklets are generated and emailed to you as soon as they are ready. This may take several minutes.',
    'Attention: any assigned goals will be marked inactive. Are you sure that you want to delete this {item}? | Are you sure that you want to delete these {item}?': 'Attention: any assigned goals will be marked inactive. Are you sure that you want to delete this {item}? | Are you sure that you want to delete these {item}?',
    'Select a graduation profile': 'Select a graduation profile',
    'Portfolio label': 'Portfolio label',
    'Add tag category': 'Add tag category',
    'Edit tag category': 'Edit tag category',
    'Add tag': 'Add tag',
    'Edit tag': 'Edit tag',
    'Save': 'Save',
    'Add goals to PLP': 'Add goals to PLP',
    'Add skill set': 'Add skill set',
    'Add document to student': 'Add document to student',
    'Add document to group': 'Add document to group',
    'Add document to project': 'Add document to project',
    'Download "This is me"': 'Download "This is me"',
    'Select skill set': 'Select skill set',
    'Basic information': 'Basic information',
    'Content': 'Content',
    'On this page you can quickly perform actions for one student, multiple students or the entire group.': 'On this page you can quickly perform actions for one student, multiple students or the entire group.',
    'Link a graduation profile to one or more students. They will then be automatically linked to the corresponding sub-areas and learning objectives. Note: learning objectives that are still linked to the "old" graduation profile will be set to inactive.': 'Link a graduation profile to one or more students. They will then be automatically linked to the corresponding sub-areas and learning objectives. Note: learning objectives that are still linked to the "old" graduation profile will be set to inactive.',
    'Use this button to automatically generate learning objectives for students who are linked to a main and/or sub-area, but for whom the objectives are not yet visible in the PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.': 'Use this button to automatically generate learning objectives for students who are linked to a main and/or sub-area, but for whom the objectives are not yet visible in the PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.',
    'Use this button when one or more students are linked to a goal set, but the learning objectives are not visible in their PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.': 'Use this button when one or more students are linked to a goal set, but the learning objectives are not visible in their PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.',
    'Remove learning objectives from the PLP of one student or the entire group.': 'Remove learning objectives from the PLP of one student or the entire group.',
    'Select students to receive their learning objectives booklets by email.': 'Select students to receive their learning objectives booklets by email.',
    'Add learning objectives to PLP': 'Add learning objectives to PLP',
    'Select students and manually add learning objectives to their PLP.': 'Select students and manually add learning objectives to their PLP.',
    'Select one or more skill sets and link them to one or more students. These will then be displayed on the "this is me" page of the student.': 'Select one or more skill sets and link them to one or more students. These will then be displayed on the "this is me" page of the student.',
    'Add document to a student': 'Add document to a student',
    'Create a document for a specific student.': 'Create a document for a specific student.',
    'Add document to a group': 'Add document to a group',
    'Create a document for the entire group.': 'Create a document for the entire group.',
    'Download "This is me" in portfolio': 'Download "This is me" in portfolio',
    'Select one or more students, give the document a name, and download it in the portfolio archive on the "this is me" page.': 'Select one or more students, give the document a name, and download it in the portfolio archive on the "this is me" page.',
    'Subject label': 'Subject label',
    'Subject labels': 'Subject labels',
    'Add subject label': 'Add subject label',
    'Status sets': 'Status sets',
    'Create status set': 'Create status set',
    'Edit status set': 'Edit status set',
    'Status labels': 'Status labels',
    'Are you sure that you want to delete {item}?': 'Are you sure that you want to delete {item}?',
    'Created at': 'Created at',
    'Default': 'Default',
    'On this page you find an overview of all the students in the group.': 'On this page you find an overview of all the students in the group.',
    'Student overview': 'Student overview',
    'Select area': 'Select area',
    'Assign goal set': 'Assign goal set',
    'Results from current year': 'Results from current year',
    'Results from the past year': 'Results from the past year',
    'All results': 'All results',
    'To view results from all years, first set the filters above for level and period.': 'To view results from all years, first set the filters above for level and period.',
    'Select which area you want to change the level and period for.': 'Select which area you want to change the level and period for.',
    'Period': 'Period',
    'Level': 'Level',
    'Change level and/or period': 'Change level and/or period',
    'Select the area for which you want to change the level and/or period. Then change the level and/or period for the students in this area.': 'Select the area for which you want to change the level and/or period. Then change the level and/or period for the students in this area.',
    'Select the area for which you want to change the level and/or period.': 'Select the area for which you want to change the level and/or period.',
    'Cancel': 'Cancel',
    'The levels and/or periods have successfully been updated.': 'The levels and/or periods have successfully been updated.',
    'Age': 'Age',
    'Select the area for which you want to change the graduation profile and then update the profile.': 'Select the area for which you want to change the graduation profile and then update the profile.',
    'Select the area for which you want to change the graduation profile.': 'Select the area for which you want to change the graduation profile.',
    'Confirm': 'Confirm',
    'Do you want to disable the the current attached graduation profile or do you want to keep it active?': 'Do you want to disable the the current attached graduation profile or do you want to keep it active?',
    'Keep active': 'Keep active',
    'Disable': 'Disable',
    'No graduation profiles found for this area': 'No graduation profiles found for this area',
    'Create new skill sets or edit and delete existing ones.': 'Create new skill sets or edit and delete existing ones.',
    'Skill set': 'Skill set',
    'Change the level and/or period for all students on the selected topic.': 'Change the level and/or period for all students on the selected topic.',
    'Selected topic': 'Selected topic',
    'Selected student': 'Selected student',
    'Change the level and/or period for all the topics for the selected student.': 'Change the level and/or period for all the topics for the selected student.',
    'Assign a new graduation profile and override or keep existing profiles.': 'Assign a new graduation profile and override or keep existing profiles.',
    'Current goal set(s)': 'Current goal set(s)',
    'No data available for the selected area': 'No data available for the selected area',
    'Apply filters': 'Apply filters',
    'No rating yet': 'No rating yet',
    'Select a graduation profile to assign to all the current selected students.': 'Select a graduation profile to assign to all the current selected students.',
    'Do you wish to disable the currently attached goals while assigning a new graduation profile or do you wish to keep these active?': 'Do you wish to disable the currently attached goals while assigning a new graduation profile or do you wish to keep these active?',
    'Manage level and period': 'Manage level and period',
    'Manage graduation profiles': 'Manage graduation profiles',
    'Manage goal sets': 'Manage goal sets',
    'Manage skill sets': 'Manage skill sets',
    'Assign skill sets to students and/or edit existing skill ratings.': 'Assign skill sets to students and/or edit existing skill ratings.',
    'No skill set added yet': 'No skill set added yet',
    'No graduation profile assigned yet': 'No graduation profile assigned yet',
    'Do you wish all topics that are not relevant for the selected graduation profile to be set to inactive, or do you wish to keep them active?': 'Do you wish all topics that are not relevant for the selected graduation profile to be set to inactive, or do you wish to keep them active?',
    'Add or edit current goal sets for students.': 'Add or edit current goal sets for students.',
    'Select a goal set': 'Select a goal set',
    'Either change the goal sets for all selected students or add and/or edit a goal set for specific students.': 'Either change the goal sets for all selected students or add and/or edit a goal set for specific students.',
    'Select a goal set for all selected students.': 'Select a goal set for all selected students.',
    'Edit the goal sets for the selected student.': 'Edit the goal sets for the selected student.',
    'Add a goal set for the selected student.': 'Add a goal set for the selected student.',
    'Do you wish to disable the currently attached goal set(s) while assigning a new goal set or do you wish to keep these active?': 'Do you wish to disable the currently attached goal set(s) while assigning a new goal set or do you wish to keep these active?',
    'No goal sets assigned yet': 'No goal sets assigned yet',
    'Goal set(s)': 'Goal set(s)',
    'Select a graduation profile for all selected students.': 'Select a graduation profile for all selected students.',
    'Edit the graduation profile for the selected student.': 'Edit the graduation profile for the selected student.',
    'Add a graduation profile for the selected student.': 'Add a graduation profile for the selected student.',
    'No skill added yet': 'No skill added yet',
    'No rating provided yet': 'No rating provided yet',
    'Assign a new skill set.': 'Assign a new skill set.',
    'Edit skill rating': 'Edit skill rating',
    'Select level': 'Select level',
    'Select period': 'Select period',
    'N/A': 'N/A',
    'Generate': 'Generate',
    'Add': 'Add',
    'Download': 'Download',
    'Delete': 'Delete',
    'Are you sure you want to delete this skill set from the user?': 'Are you sure you want to delete this skill set from the user?',
    'Change the level and/or period for all students for all topics at once.': 'Change the level and/or period for all students for all topics at once.',
    'There still area actives goals for the student(s), do you wish to keep these active or should they be deactivated and should only the new goals be prepared?': 'There still area actives goals for the student(s), do you wish to keep these active or should they be deactivated and should only the new goals be prepared?',
    'Select a student': 'Select a student',
    'Choose student': 'Choose student',
    'Sort by age': 'Sort by age',
    'If there still are goals active for the student from the goal set(s) which you now remove, do you wish to keep these active or should they be deactivated and should only the new goals be prepared?': 'If there still are goals active for the student from the goal set(s) which you now remove, do you wish to keep these active or should they be deactivated and should only the new goals be prepared?',
    'Select a goal set to add for all selected students.': 'Select a goal set to add for all selected students.',
    'Years': 'Years',
    'This is me': 'This is me',
    'This is me label': 'This is me label',
    'This is you label': 'This is you label',
    'Photo album label': 'Photo album label',
    'Student label': 'Student label',
    'Teacher label': 'Teacher label',
    'Parent label': 'Parent label',
    'At least one tag': 'At least one tag',
    'All selected tags': 'All selected tags',
    'Has admin rights': 'Has admin rights',
    'Admin view enabled': 'Admin view enabled',
    'No results': 'No results',
    'Goal set category': 'Goal set category',
    'Goal set categories': 'Goal set categories',
    'Amount of goal sets': 'Amount of goal sets',
    'All goal set categories': 'All goal set categories',
    'Add goal set category': 'Add goal set category',
    'Edit goal set category': 'Edit goal set category',
    'Created by': 'Created by',
    'Evaluation': 'Evaluation',
    'Monday': 'Monday',
    'Tuesday': 'Tuesday',
    'Wednesday': 'Wednesday',
    'Thursday': 'Thursday',
    'Friday': 'Friday',
    'Enter text here...': 'Enter text here...',
    'Insert column right': 'Insert column right',
    'Insert column left': 'Insert column left',
    'Insert row up': 'Insert row up',
    'Insert row down': 'Insert row down',
    'Delete column': 'Delete column',
    'Delete row': 'Delete row',
    'Delete table': 'Delete table',
    'No files found': 'No files found',
    'No portfolio archives found': 'No portfolio archives found',
    'Include steps': 'Include steps',
    'Select for which selected area you wish to include the steps.': 'Select for which selected area you wish to include the steps.',
    'Select statuses': 'Select statuses',
    'Select which statuses you wish to include in the download.': 'Select which statuses you wish to include in the download.',
    'Add text field': 'Add text field',
    'My goal set categories': 'My goal set categories',
    'Goal sets': 'Goal sets',
    'Edit goal set': 'Edit goal set',
    'Provide feedback on the project': 'Provide feedback on the project',
    'Evaluation successfully saved': 'Evaluation successfully saved',
    'Files': 'Files',
    'Documents': 'Documents',
    'Goal set document': 'Goal set document',
    'Goal set documents': 'Goal set documents',
    'View': 'View',
    'View and edit': 'View and edit',
    'Curriculum': 'Curriculum',
    'Add document to {item}': 'Add document to {item}',
    'Edit document for {item}': 'Edit document {item}',
    'Add document': 'Add document',
    'Edit document': 'Edit document',
    'Success': 'Success',
    'Document successfully added': 'Document successfully added',
    'Document successfully edited': 'Document successfully edited',
    'No evaluation added yet.': 'No evaluation added yet.',
    'Goal set': 'Goal set',
    'Unknown': 'Unknown',
    'Category': 'Category',
    'Add or read the evaluation of the goal set': 'Add or read the evaluation of the goal set',
    'Add or read the goal set plan': 'Add or read the goal set plan',
    'Add or view files related to the goal set': 'Add or view files related to the goal set',
    'Create your goal set here': 'Create your goal set here',
    'Document type': 'Document type',
    'Document item': 'Document item',
    'Group': 'Group',
    'Student': 'Student',
    'Assigned projects': 'Assigned projects',
    'On this page you can quickly view all assigned goal sets to the group as a whole. Note: not all students from the group are assigned to the same goal set.': 'On this page you can quickly view all assigned goal sets to the group as a whole. Note: not all students from the group are assigned to the same goal set.',
    'No goal sets assigned yet to students in this group.': 'No goal sets assigned yet to students in this group.',
    'Here you can see the menu with all goal sets that are assigned to this group.': 'Here you can see the menu with all goal sets that are assigned to this group.',
    'Personal': 'Personal',
    'Back to my account': 'Back to my account'
};
export default translation;
